import { Grid, Tab, Tabs, Typography } from "@mui/material";
import * as api from "api/Core";
import { GlobalClassKeys } from "assets/jss/common-styles";
import { AppMessageBox } from "components/AppMessageBox";
import { AppTabs } from "components/AppTabs";
import { SpinnerIndicator } from "components/CallServer";
import IconAwardPoints from "components/Icons/IconAwardPoints";
import IconBadge from "components/Icons/IconBadge";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import LibUtils from "lib/LibUtils";
import { DashboardAwardAnalysisDetailColumn, DashboardAwardAnalysisPeriod, DashboardAwardAnalysisResumeModel } from "models/ApiModels";
import moment from "moment";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { DashboardAwardAnalysisProps } from "views/Dashboards/AwardAnalysisDashboard/Common";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: DashboardAwardAnalysisResumeModel;
    loading: boolean;
    tabOption: DashboardAwardAnalysisPeriod;
}

type Props = DashboardAwardAnalysisProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class AwardAnalysisIndicatorsComponent extends React.PureComponent<Props, IState>{

    constructor(props: Props) {
        super(props);

        this.state = {
            data: null,
            loading: true,
            tabOption: DashboardAwardAnalysisPeriod.Last30
        };
    }

    ///
    private getDateFilter() {

        if (this.state.tabOption == DashboardAwardAnalysisPeriod.Total)
            return { startDate: null, endDate: null };

        var de = moment().utc().endOf("day");
        var ds = moment().utc().startOf("day");
        ds.add(-29, "days");
        return { startDate: ds.toDate(), endDate: de.toDate() };
    }

    ///
    private loadData() {

        this.setState({ data: null, loading: true });

        api.getDashboardAwardAnalysis({
            detailColumn: DashboardAwardAnalysisDetailColumn.Resume,
            ...this.getDateFilter(),
            ...this.props.filter,
            range: null,
        })
            .then((result: DashboardAwardAnalysisResumeModel) => {
                this.setState({ data: result, loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false });
            });
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        if (!LibUtils.isEqual(this.props.filter, prevProps.filter)) {
            this.loadData();
        }
    }

    ///
    public render() {
        const { loading, tabOption, data } = this.state;

        if (data == null && !loading)
            return <AppMessageBox resource="LoadGraphDataFailed" />;

        return (
            <div>

                <MuiContainer margin="normal">
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            <Typography component="p" variant="h6"><b>{this.props.t("Views.Dashboards.AwardAnalysis.Indicators.HeaderTitle").toString().toLocaleUpperCase()}</b></Typography>
                        </Grid>

                        {
                            <Grid item>
                                <AppTabs
                                    value={tabOption}
                                    onChange={
                                        (e, newValue: DashboardAwardAnalysisPeriod) => {
                                            this.setState({ tabOption: newValue }, () => this.loadData());
                                        }
                                    }
                                    indicatorColor="primary"
                                    textColor="primary"
                                >
                                    <Tab label={this.props.t<string>("Views.Dashboards.Common.LastMonth")} value={DashboardAwardAnalysisPeriod.Last30} />
                                    <Tab label={this.props.t<string>("Views.Dashboards.Common.FullPeriod")} value={DashboardAwardAnalysisPeriod.Total} />
                                </AppTabs>

                            </Grid>
                        }
                    </Grid>
                </MuiContainer>

                <MuiColor variant="warning">
                    <Grid container justifyContent="space-between" spacing={2}>
                        <Grid item>
                            <Grid container justifyContent="space-between" alignItems="center" spacing={3} >
                                <Grid item>
                                    <IconAwardPoints size="5x" color="inherit" />
                                </Grid>
                                <Grid item className={GlobalClassKeys.textCenter}>
                                    {
                                        loading
                                            ? <SpinnerIndicator />
                                            : <>
                                                <Typography variant="h5">
                                                    <b>{data.totalPoints}</b>
                                                </Typography>

                                                <Typography variant="button">
                                                    <div>{this.props.t("Views.Dashboards.AwardAnalysis.Indicators.PointsLine1")}</div>
                                                    {(this.props.filter.memberId == null)
                                                        ? <div>{this.props.t("Views.Dashboards.AwardAnalysis.Indicators.PointsLine2", { count: data.totalPointsByUser })} </div>
                                                        : ""
                                                    }

                                                </Typography>
                                            </>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container justifyContent="space-between" alignItems="center" spacing={3}>
                                <Grid item>
                                    <IconBadge size="5x" color="inherit" />
                                </Grid>
                                <Grid item className={GlobalClassKeys.textCenter}>
                                    {
                                        loading
                                            ? <SpinnerIndicator />
                                            : <>
                                                <Typography variant="h5">
                                                    <b>{data.totalBadges}</b>
                                                </Typography>
                                                <Typography variant="button">
                                                    <div>{this.props.t("Views.Dashboards.AwardAnalysis.Indicators.MedalsLine1")}</div>
                                                    {(this.props.filter.memberId == null)
                                                        ? <div>{this.props.t("Views.Dashboards.AwardAnalysis.Indicators.MedalsLine2", { count: data.totalBadgesByUser })}</div>
                                                        : ""
                                                    }
                                                </Typography>
                                            </>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </MuiColor>

            </div>
        );
    }
}

export const AwardAnalysisIndicators = withTranslation()(AwardAnalysisIndicatorsComponent);